import React from 'react';
import classNames from 'classnames';

import styles from './index.sass';

export default ({Element, inverted, className, active, before, ...props}) => {
    if (Element === undefined) {
        Element = 'div';
    }

    return (
        <Element {...props} className={classNames(styles.root, {active, [styles.inverted]: inverted}, className)}>
            {before}
            <svg width="56" height="37" viewBox="0 0 56 37">
                <path d="M56.2 14C56.2 6.3 50 0 42.2 0c-0.9 0-1.8 0.1-2.7 0.3L10.7 7.8C4.5 9.3 0 14.8 0 21.4c0 3.5 1.3 6.6 3.4 9.1l-2.2 6.3 7.3-2.5c1.7 0.8 3.6 1.2 5.6 1.2 7.2 0 13.2-5.5 13.9-12.5l3-0.7c2.5 3.5 6.7 5.8 11.4 5.8 2 0 3.9-0.4 5.6-1.2l7.3 2.6 -2.2-6.3C55 20.6 56.2 17.5 56.2 14zM20.6 22.7c0 0.6-0.5 1.2-1.2 1.2h-2.1c-0.6 0-1.2 0.5-1.2 1.2v2.1c0 0.6-0.5 1.2-1.2 1.2h-1.9c-0.6 0-1.2-0.5-1.2-1.2v-2.1c0-0.6-0.5-1.2-1.2-1.2H8.6c-0.6 0-1.2-0.5-1.2-1.2v-1.9c0-0.6 0.5-1.2 1.2-1.2h2.1c0.6 0 1.2-0.5 1.2-1.2v-2.1c0-0.6 0.5-1.2 1.2-1.2h1.9c0.6 0 1.2 0.5 1.2 1.2v2.1c0 0.6 0.5 1.2 1.2 1.2h2.1c0.6 0 1.2 0.5 1.2 1.2V22.7zM37.2 16.5c-1.3 0-2.3-0.9-2.4-2.2s1-2.3 2.2-2.4c1.3 0 2.3 1 2.4 2.2C39.5 15.3 38.5 16.4 37.2 16.5zM42 6.5c1.3 0 2.3 1 2.4 2.2 0.1 1.3-0.9 2.3-2.2 2.4 -1.3 0.1-2.3-0.9-2.4-2.2S40.7 6.6 42 6.5zM42.5 21.4c-1.3 0.1-2.3-0.9-2.4-2.2 0-1.3 1-2.3 2.2-2.4 1.3 0 2.3 1 2.4 2.2S43.8 21.4 42.5 21.4zM47.5 16.1c-1.3 0.1-2.3-0.9-2.4-2.2 0-1.3 1-2.3 2.2-2.4 1.3 0 2.3 1 2.4 2.2S48.7 16 47.5 16.1z"/>
            </svg>
            <h2>
                Gamedev<span>.js</span>
            </h2>
        </Element>);
};



// WEBPACK FOOTER //
// ./src/elements/brand/Logo/index.js